import { Atom } from 'AppReact';
import styled from "styled-components";

const template = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 8px;
  display: flex;
  top: 0px;
  left: 0px;
  background-color: rgb(4, 51, 59, 0.6);
  backdrop-filter: blur(6px);
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
  font-size: 20px;
  font-weight: 600;
`;


export default Atom({ type: 'label', dataType: 'string', template })